import dayjs from "dayjs"

export const clearFilterData = {
  FuelTmSt: null,
  FuelTmEn: null,
  Saldte: null
}

export const initFilterData = {
  ...clearFilterData,
  SalDte: dayjs().format("YYYY-MM-01 00:00:00"),
}